import React from 'react';
import PropTypes from 'prop-types';

import RacingThemeListingCard from '../RacingThemeListingCard/RacingThemeListingCard';
import { SEARCH_LISTINGS } from '../RacingThemeSearch/searchResultsContent';
import { getDepartmentActionLabel } from '../../util/racingThemeDepartment';
import { FAVORITE_TYPE_LISTING } from '../../util/favorites';
import styles from './RacingThemeSearchResultsGrid.module.css';

const listingShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  tag: PropTypes.string,
  department: PropTypes.oneOf(['shop', 'book', 'partner']),
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  price: PropTypes.string.isRequired,
  location: PropTypes.string,
  rating: PropTypes.number,
  reviewCount: PropTypes.number,
  filledStars: PropTypes.number,
  href: PropTypes.string,
  actionLabel: PropTypes.string,
  isFavorite: PropTypes.bool,
});

/**
 * Search results card grid.
 */
const RacingThemeSearchResultsGrid = props => {
  const { listings = SEARCH_LISTINGS, onToggleFavorite = null } = props;

  return (
    <div className={styles.resultsGrid}>
      {listings.map(listing => (
        <RacingThemeListingCard
          key={listing.id}
          variant="search"
          tag={listing.tag}
          department={listing.department}
          image={listing.image}
          imageAlt={listing.imageAlt}
          title={listing.title}
          subtitle={listing.subtitle}
          price={listing.price}
          location={listing.location}
          rating={listing.rating}
          reviewCount={listing.reviewCount}
          filledStars={listing.filledStars}
          href={listing.href}
          actionLabel={listing.actionLabel || getDepartmentActionLabel(listing.department)}
          favoriteType={FAVORITE_TYPE_LISTING}
          favoriteId={listing.id}
          isFavorite={!!listing.isFavorite}
          onToggleFavorite={onToggleFavorite}
        />
      ))}
    </div>
  );
};

RacingThemeSearchResultsGrid.propTypes = {
  listings: PropTypes.arrayOf(listingShape),
  onToggleFavorite: PropTypes.func,
};

export default RacingThemeSearchResultsGrid;
